
import { TRACKERS } from "./trackingFlags";

/**
 * Determines the final platforms to send the event to,
 * based on the global TRACKERS config.
 *
 * @param {Array|string} requestedPlatforms - "all" or a list like ["facebookPixel", "googleAnalytics"]
 * @returns {{ client: Array, server: Array }} - Platform groups to track
 */
export const resolvePlatforms = (requestedPlatforms = "all") => {
  const allPlatforms = {
    client: [
      { key: "googleAnalytics", enabled: TRACKERS.GOOGLE },
      { key: "facebookPixel", enabled: TRACKERS.FACEBOOK },
      { key: "tiktokPixel", enabled: TRACKERS.TIKTOK },
      { key: "pinterestPixel", enabled: TRACKERS.PINTEREST },
      { key: "inMarket", enabled: TRACKERS.INMARKET },
    ],
    server: TRACKERS.SERVER_TRACKING ? ["Meta", "Pinterest"] : [],
  };

  const allowed = (list) =>
    list
      .filter((item) =>
        typeof item === "string"
          ? true
          : item.enabled && (requestedPlatforms === "all" || requestedPlatforms.includes(item.key))
      )
      .map((item) => (typeof item === "string" ? item : item.key));

  return {
    client: allowed(allPlatforms.client),
    server: allowed(allPlatforms.server),
  };
};
